import React from "react";
import { connect } from "react-redux";
import Modal from "reboron/DropModal";
import { FormattedMessage } from "react-intl";

import { fetchP24TransactionsByFilter, createTransaction } from "../../../actions/p24TransactionActions";
import { fetchP24TransactionLogs } from "../../../actions/p24TransactionLogActions";



import { PageHeader } from "../../../components/PageHeader";
import LoadingTable from "../../../components/LoadingTable";
import P24TransactionForm from "../../../components/p24/P24TransactionForm";

import { formatDateTime, formatMoneyDiv100 } from "../../../helpers/utils";
import { getP24TransactionStatusById } from "../../../constants/P24TransactionStatus";
import { getP24TransactionRefundStatusById } from "../../../constants/P24TransactionRefundStatus";

import { getP24TransactionType } from "../../../constants/P24TransactionType";
import P24BlikChargeByCodeForm from "../../../components/p24/P24BlikChargeByCodeForm";
import P24TransactionDataByP24 from "../../../components/p24/P24TransactionDataByP24";
import P24TransactionRefundsDataByP24 from "../../../components/p24/P24TransactionRefundsDataByP24";
import P24TransactionRefunds from "../../../components/p24/P24TransactionRefunds";
import P24TransactionStatusByP24 from "../../../components/p24/P24TransactionStatusByP24"

import P24TransactionRefundForm from "../../../components/p24/P24TransactionRefundForm";
import P24TransactionFilter from "../../../components/p24/P24TransactionFilter";
import P24TrasactionLogs from "../../../components/p24/P24TransactionLogs";

// Individual styles for the modal, modal content, and backdrop
const modalStyle = {
    //transform: 'rotate(45deg) translateX(-50%)',
    //width: '80%'
    width: '800px'
};

const backdropStyle = {
    // backgroundColor: 'red',
};

const contentStyle = {
    // backgroundColor: 'blue',
    height: '100%',
};


/**
 * Transakcje P24
 */
class P24Transactions extends React.Component {

    state = {
        //wybrana transakcja
        selectedTransaction: {},
        //domyśnie rozwinięte wiersze połączeń {index:true}, np {0, true}- oznacza rozwinięcie pierwszero wiersza w tabelce
        //na ten moment wspieramy rozszerzalność tylko jednego wiersza na raz
        expandedRows: {}
    };

    componentDidMount() {

        //ladowanie danych do tabeli na podstawie filtra
        this.props.fetchP24TransactionsByFilter(this.props.p24TransactionFilter);
    }

    /**
    * Kolumny do tabelki
    */
    tableColumns = [
        {
            Header: this.props.formatMessage("p24Transaction.id"),
            accessor: "id",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.props.formatMessage("p24Transaction.transactionType"),
            id: "transactionType",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            accessor: data => getP24TransactionType(data.transactionType).displayText,
        },
        {
            Header: this.props.formatMessage("p24Transaction.restaurantId"),
            accessor: "restaurantId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.props.formatMessage("p24Transaction.sandbox"),
            id: "sandbox",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 80,
            accessor: data => data.sandbox,
            Cell: row => {
                if (row.original.sandbox) {
                    return (
                        <div className="w3-center">
                            <span className="w3-large w3-text-theme"><i className="fas fa-check"></i></span>
                        </div>
                    )
                }
                return null;
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.p24Refund"),
            id: "refundCount",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 80,
            Cell: row => {
                if (row.original.refundCount > 0) {
                    return (
                        <div className="w3-center">
                            <span className="w3-large w3-text-theme"><i className="fas fa-check"></i></span>
                        </div>
                    )
                }
                return null;
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.amount"),
            id: "amount",
            accessor: (data) => formatMoneyDiv100(data.amount),
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 100
        },
        {
            Header: this.props.formatMessage("p24Transaction.email"),
            accessor: "email",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 250
        },
        {
            Header: this.props.formatMessage("p24Transaction.description"),
            accessor: "description",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" }
        },
        {
            Header: this.props.formatMessage("p24Transaction.p24Status"),
            id: "p24Status",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            accessor: data => getP24TransactionStatusById(data.p24Status).displayText,
        },
        {
            Header: this.props.formatMessage("p24Transaction.creationDate"),
            id: "creationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.creationDate);
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.verificationDate"),
            id: "verificationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.verificationDate);
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.p24RefundStatus"),
            id: "p24RefundStatus",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            accessor: data => data.p24RefundStatus,
            Cell: row => {
                const refundStatus = getP24TransactionRefundStatusById(row.original.p24RefundStatus);
                const clazzName = `w3-large w3-text-${refundStatus.colorCss}`

                return (
                    <div className="w3-center">
                        <span className={clazzName}><i className={refundStatus.iconCss}></i></span>
                    </div>
                )
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.refundTotalAmount"),
            id: "refundTotalAmount",
            accessor: (data) => {

                if (data.refundCount > 0) {
                    return formatMoneyDiv100(data.refundTotalAmount)
                }
                else {
                    return null;
                }
            }
            ,
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 100
        },
        {
            Header: this.props.formatMessage("p24Transaction.refundRegistrationDate"),
            id: "refundRegistrationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.refundRegistrationDate);
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.refundNotificationDate"),
            id: "refundNotificationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.refundNotificationDate);
            }
        },
        {
            Header: this.props.formatMessage("p24Transaction.p24Statement"),
            accessor: "p24Statement",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" }
        },
        {
            Header: this.props.formatMessage("p24Transaction.p24Method"),
            id: "p24Method",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            Cell: row => {
                if (row.original.p24Method) {
                    return (
                        <div>
                            <img src={`https://static.przelewy24.pl/payment-form-logo/svg/${row.original.p24Method}`} alt="payment method" style={{ height: '39px' }} />
                        </div>
                    )
                }
                return null;
            }

        },

        /*
        {
            Header: this.props.formatMessage("p24Transaction.p24UrlPayment"),
            id: "p24UrlPayment",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "center" },
            maxWidth: 180,
            //accessor: data => data.p24UrlPayment,
            Cell: row => {
                // console.log(row)
                // console.log(row.p24UrlPayment)

                //czy pokazac link do platnosci
                let showPayLinkResult = showPayLink(row.original.p24Status);

                if (showPayLinkResult) {
                    return (
                        <div>
                            <a href={row.original.p24UrlPayment} target="_blank">Zapłać</a>
                        </div>
                    )
                } else {
                    return (
                        <div>

                        </div>
                    )
                }


            },
        },
    */
        {
            expander: true,
            style: { whiteSpace: "unset", textAlign: "center" },
            width: 30,
            sortable: false,
            filterable: false,
            Expander: ({ isExpanded, ...rest }) => {
                return (
                    <div>{isExpanded ? <span className="w3-large w3-text-theme"><i className="fas fa-minus"></i></span> : <span className="w3-large w3-text-theme"><i className="fas fa-plus"></i></span>}</div>
                );
            }
        }
    ];

    /**
   * Sub Komponent, który pojawia się dla wiersza rozrzerzonego
   * 
   * {@param row} model wiersza w tabelce
   */
    subComponent = (row) => {

        const transaction = row.original;

        return (
            <div className="w3-theme-l4">
                <div className="w3-panel w3-small">



                </div>

                <div className="w3-small">

                    <div className="w3-row-padding">
                        <div className="w3-col s2">
                            <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                                {transaction.id}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.id"
                                    defaultMessage="id"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.sessionId}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.sessionId"
                                    defaultMessage="sessionId"
                                />
                            </label>
                        </div>

                        <div className="w3-col s4">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.p24Token}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24Token"
                                    defaultMessage="p24Token"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                                {transaction.p24OrderId}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24OrderId"
                                    defaultMessage="p24OrderId"
                                />
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.blikCode}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.blikCode"
                                    defaultMessage="blikCode"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.blikRegistrationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.blikRegistrationDate"
                                    defaultMessage="blikRegistrationDate"
                                />
                            </label>
                        </div>


                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.blikNotificationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.blikNotificationDate"
                                    defaultMessage="blikNotificationDate"
                                />
                            </label>
                        </div>


                        <div className="w3-col s2">
                            <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                                {transaction.p24BlikTransactionNr}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24BlikTransactionNr"
                                    defaultMessage="p24BlikTransactionNr"
                                />
                            </label>
                        </div>
                        <div className="w3-col s2">
                            <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                                {transaction.p24BlikTransactionStatus}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24BlikTransactionStatus"
                                    defaultMessage="p24BlikTransactionStatus"
                                />
                            </label>
                        </div>
                        <div className="w3-col s2">
                            <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                                {transaction.p24BlikTransactionMsg}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24BlikTransactionMsg"
                                    defaultMessage="p24BlikTransactionMsg"
                                />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.p24Statement}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24Statement"
                                    defaultMessage="p24Statement"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.description}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.description"
                                    defaultMessage="description"
                                />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.creationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.creationDate"
                                    defaultMessage="creationDate"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.registrationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.registrationDate"
                                    defaultMessage="registrationDate"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.notificationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.notificationDate"
                                    defaultMessage="notificationDate"
                                />
                            </label>
                        </div>


                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.verificationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.verificationDate"
                                    defaultMessage="verificationDate"
                                />
                            </label>
                        </div>


                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.refundRegistrationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.refundRegistrationDate"
                                    defaultMessage="refundRegistrationDate"
                                />
                            </label>
                        </div>

                        <div className="w3-col s2">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {formatDateTime(transaction.refundNotificationDate)}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.refundNotificationDate"
                                    defaultMessage="refundNotificationDate"
                                />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s6">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.urlReturn}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.urlReturn"
                                    defaultMessage="urlReturn"
                                />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s6">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.urlStatus}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.urlStatus"
                                    defaultMessage="urlStatus"
                                />
                            </label>
                        </div>


                        <div className="w3-col s6">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.p24UrlPayment}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24UrlPayment"
                                    defaultMessage="p24UrlPayment"
                                />
                            </label>
                        </div>




                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s6">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.p24UrlCardPaymentNotification}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24UrlCardPaymentNotification"
                                    defaultMessage="p24UrlCardPaymentNotification"
                                />
                            </label>
                        </div>
                        <div className="w3-col s6">
                            <span className="w3-input" style={{ height: '39px' }}>
                                {transaction.p24UrlTransactionStatus}
                            </span>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Transaction.p24UrlTransactionStatus"
                                    defaultMessage="p24UrlTransactionStatus"
                                />
                            </label>
                        </div>
                    </div>




                    <br />

                    <div className="w3-padding">

                        <a
                            className="w3-btn w3-theme width200 w3-margin-right"
                            href={row.original.p24UrlPayment} target="_blank" rel="noopener noreferrer"
                        >
                            Zapłać - poprzez Przelewy24
                        </a>

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            onClick={() => this.onRowBlikChargeByCode(row.original)}
                        >
                            Zapłać - poprzez BLIK
                        </button>
                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowRefundTransactionClick(row.original)}
                        >
                            Zwrot transakcji
                        </button>

                    </div>
                    <div className="w3-padding">

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowTransactionStatusByP24(row.original)}
                        >
                            Status Transakcji z P24
                        </button>
                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowTransactionDataByP24(row.original)}
                        >
                            Dane Transakcji z P24
                        </button>
                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowTransactionRefundsDataByP24(row.original)}
                        >
                            Dane Zwrotów z P24
                        </button>


                    </div>

                    <div className="w3-padding">

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowTransactionRefunds(row.original)}
                        >
                            Dane Zwrotów z Flow24
                        </button>
                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            type="reset"
                            onClick={() => this.onRowTransactionLogsClick(row.original)}
                        >
                            Dane Logów z Flow24
                        </button>

                    </div>

                </div>

            </div>
        )
    }

    /**
   * Akcja na zmianę rozszerzalności w tabelce
   * 
   * W stanie komponentu zapamiętujemy aktualnie rozszerzny wiersz.
   * 
   * Może być tylko jeden rozszerzony wiersz na raz.
   */
    onExpandedChange = (newExpanded, index, event, cellInfo) => {
        let newExpandedRows = {}
        let rowIndex = index[0];
        if (newExpanded[rowIndex] === false) {
            //wiersz odznaczony - ustawiamy index na false
            newExpandedRows = {};
        } else {
            //wiersz zaznaczony - ustawiamy index wiersza na true
            newExpandedRows = { [rowIndex]: true };
        }

        this.setState({
            ...this.state,
            expandedRows: newExpandedRows,
        });
    }

    onRowBlikChargeByCode(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalBlikChargeByCode();
    }

    onRowTransactionDataByP24(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalTransactionDataByP24();
    }

    onRowRefundTransactionClick(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalRefundTransaction();
    }

    onRowTransactionRefundsDataByP24(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalTransactionRefundsDataByP24();
    }

    onRowTransactionRefunds(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalTransactionRefunds();
    }

    /**
     * Akcja po kliknieciu na zadanie o logi transakcji
     */
    onRowTransactionLogsClick = (transaction) => {

        this.setState({
            selectedTransaction: transaction
        })

        //pobranie danych logów wybranej transakcji
        this.props.fetchP24TransactionLogs(transaction.id);




        //pokazujemy modal z logami
        this.showModalTransactionLogs();
    }

    onRowTransactionStatusByP24(data) {

        this.setState({
            selectedTransaction: data
        })

        //pokazujemy modala z placenien blik

        this.showModalTransactionStatusByP24();
    }



    /**
    * Pokazuje modal rejestracji transakcji
    */
    showModalRegisterTransaction() {
        this.refs.modal_registerTransaction.show();
    }

    /**
     * Chowa modal rejestracji transakcji
     */
    hideModalRegisterTransaction = () => {
        this.refs.modal_registerTransaction.hide();
    };

    /**
    * Pokazuje modal
    */
    showModalBlikChargeByCode() {
        this.refs.modal_blikChargeByCode.show();
    }

    /**
     * Chowa modal
     */
    hideModalBlikChargeByCode = () => {
        this.refs.modal_blikChargeByCode.hide();
    };

    /**
    * Pokazuje modal
    */
    showModalTransactionDataByP24() {
        this.refs.modal_transactionDataByP24.show();
    }

    /**
     * Chowa modal
     */
    hideModalTransactionDataByP24 = () => {
        this.refs.modal_transactionDataByP24.hide();
    };

    /**
   * Pokazuje modal
   */
    showModalTransactionStatusByP24() {
        this.refs.modal_transactionStatusByP24.show();
    }

    /**
     * Chowa modal
     */
    hideModalTransactionStatusByP24 = () => {
        this.refs.modal_transactionStatusByP24.hide();
    };

    /**
   * Pokazuje modal
   */
    showModalTransactionRefundsDataByP24() {
        this.refs.modal_transactionRefundsDataByP24.show();
    }

    /**
     * Chowa modal
     */
    hideModalTransactionRefundsDataByP24 = () => {
        this.refs.modal_transactionRefundsDataByP24.hide();
    };

    /**
  * Pokazuje modal
  */
    showModalTransactionRefunds() {
        this.refs.modal_transactionRefunds.show();
    }

    /**
     * Chowa modal
     */
    hideModalTransactionRefunds = () => {
        this.refs.modal_transactionRefunds.hide();
    };



    /**
    * Pokazuje modal z logami transakcji
    */
    showModalTransactionLogs() {
        this.refs.modal_transactionLogs.show();
    }

    /**
     * Chowa modal z logami transakcji
     */
    hideModalTransactionLogs = () => {
        this.refs.modal_transactionLogs.hide();
    };










    /**
    * Pokazuje modal
    */
    showModalRefundTransaction() {
        this.refs.modal_refundTransaction.show();
    }

    /**
     * Chowa modal
     */
    hideModalRefundTransaction = () => {
        this.refs.modal_refundTransaction.hide();
    };

    addButton() {
        return <button
            className="w3-btn w3-theme-dark"
            onClick={() => this.showModalRegisterTransaction()}
        >
            {this.props.formatMessage("app.p24TransactionPage.addTransaction")}
        </button>
    }

    /**
     * Akcja na wywolanie rejestracji nowej transakcji 
     * 
     * @param {P24ImplementationType} p24ImplementationType typ implementacji
     * @param {Object} transaction model nowej transakcji
     */
    handleTransactionRegister = async (p24ImplementationType, transaction) => {
        try {
            await this.props.createTransaction(p24ImplementationType, transaction);
            this.hideModalRegisterTransaction();
        } catch (error) {
            console.log('error', error);
        }
    }

    onFilterChange = () => {
        //ladowanie danych do tabeli - po aktualizacji filtra
        this.props.fetchP24TransactionsByFilter(this.props.p24TransactionFilter);
    }

    render() {

        return (
            <div>
                <PageHeader text="app.p24TransactionPage.title" />

                <P24TransactionFilter onFilterChange={this.onFilterChange} />

                <br />

                {this.addButton()}

                <LoadingTable
                    data={this.props.p24TransactionList}
                    columns={this.tableColumns}
                    loading={false}
                    SubComponent={this.subComponent}
                    onExpandedChange={this.onExpandedChange}
                    expanded={this.state.expandedRows}
                />
                <Modal ref={"modal_registerTransaction"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionForm title='Nowa transakcja' onCancel={this.hideModalRegisterTransaction} onSubmit={this.handleTransactionRegister} />
                </Modal>
                <Modal ref={"modal_blikChargeByCode"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24BlikChargeByCodeForm transaction={this.state.selectedTransaction} onCancel={this.hideModalBlikChargeByCode} onSubmit={this.hideModalBlikChargeByCode} />
                </Modal>
                <Modal ref={"modal_transactionDataByP24"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionDataByP24 transaction={this.state.selectedTransaction} onSubmit={this.hideModalTransactionDataByP24} />
                </Modal>
                <Modal ref={"modal_transactionRefundsDataByP24"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionRefundsDataByP24 transaction={this.state.selectedTransaction} onSubmit={this.hideModalTransactionRefundsDataByP24} />
                </Modal>
                <Modal ref={"modal_transactionRefunds"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionRefunds transaction={this.state.selectedTransaction} onSubmit={this.hideModalTransactionRefunds} />
                </Modal>
                <Modal ref={"modal_transactionStatusByP24"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionStatusByP24 transaction={this.state.selectedTransaction} onSubmit={this.hideModalTransactionStatusByP24} />
                </Modal>
                <Modal ref={"modal_refundTransaction"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionRefundForm transaction={this.state.selectedTransaction} onCancel={this.hideModalRefundTransaction} onSubmit={this.hideModalRefundTransaction} />
                </Modal>
                <Modal ref={"modal_transactionLogs"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TrasactionLogs logs={this.props.p24TransactionLogList} onSubmit={this.hideModalTransactionLogs} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    p24TransactionFilter: state.p24TransactionReducer.p24TransactionFilter,
    p24TransactionList: state.p24TransactionReducer.p24TransactionList,
    p24TransactionLogList: state.p24TransactionLogReducer.p24TransactionLogList,
    authenticatedUser: state.authReducer.authenticatedUser
});


const mapDispatchToProps = ({
    fetchP24TransactionsByFilter: fetchP24TransactionsByFilter,
    createTransaction: createTransaction,
    fetchP24TransactionLogs: fetchP24TransactionLogs

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24Transactions);